import AnimatedHourglass from './animated/hourglass/AnimatedHourglassIcon';
import Youtube from './YoutubeIcon';

export default { AnimatedHourglass, Youtube };
